import A from './types';
// account level {public:0, free:1, standard:2, premium:3}
const initialState = {
  profileAccountInfo: {},
  profilePasswordInfo: {},
};

const reducer = (state, action) => {
  switch (action.type) {
    case A.PROFILE_PAGE_SAVE_ACCOUNT_INFO: {
      if (action.pending) {
        return {
          ...state,
          profileAccountInfo: {
            disable: true,
            error: false,
          },
        };
      }
      return {
        ...state,
        profileAccountInfo: {
          disable: false,
          error: action.payload.message === 'success' ? 'Update Successful' : action.payload.message,
        },
      };
    }
    case A.PROFILE_PAGE_ASYNG_ERROR_HIDE: {
      return {
        ...state,
        [action.payload.type]: {
          ...[action.payload.type],
          error: false,
          disable: false,
        },
      };
    }
  }
  return null;
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/accountProfilePage/reducer.js